import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	unAuthPluginStatus: {
		fontWeight: 500,
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[100])
	},
	authPluginStatus: {
		fontWeight: 500,
		...ColorUtil.getBackgroundAndContrastColor(colors.green[600])
	},
	authPluginButton: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[100]),
		border: "1px solid",
		boxShadow: "none",
		borderColor: "rgba(126, 13, 214, 0.12)",
		fontWeight: 500,
		fontSize: "16px",
		color: colors.getPrimaryColor(),
		letterSpacing: 0.4,
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.purple[300]),
			boxShadow: "none"
		}
	},
	tipsContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		borderRadius: theme.spacing(1),
		padding: theme.spacing(1.5, 2)
	},
	tipsIcon: {
		fontSize: "1rem",
		marginBottom: "3px"
	},
	tipsHeaderText: {
		fontSize: theme.spacing(1.5),
		color: colors.getPrimaryColor(),
		fontWeight: 500
	},
	tipsContentText: {
		fontSize: theme.spacing(1.75),
		color: colors.gray[600],
		fontWeight: 400
	}
}))

export default useStyles
